import {
  ADD_EMPLOYMENT_TYPE_FAIL,
  ADD_EMPLOYMENT_TYPE_SUCCESS,
  ADD_EMPLOYMENT_TYPE_REQUEST,
  DELETE_EMPLOYMENT_TYPE_REQUEST,
  DELETE_EMPLOYMENT_TYPE_SUCCESS,
  GETDETAIL_EMPLOYMENT_TYPE_REQUEST,
  GETDETAIL_EMPLOYMENT_TYPE_FAIL,
  GETDETAIL_EMPLOYMENT_TYPE_SUCCESS,
  UPDATE_EMPLOYMENT_TYPE_FAIL,
  UPDATE_EMPLOYMENT_TYPE_SUCCESS,
  UPDATE_EMPLOYMENT_TYPE_REQUEST,
  DELETE_EMPLOYMENT_TYPE_FAIL,
  GETALL_EMPLOYMENT_TYPE_FAIL,
  GETALL_EMPLOYMENT_TYPE_SUCCESS,
  GETALL_EMPLOYMENT_TYPE_REQUEST,
  CLEAR_EMPTYPE_RECORD,
} from "../constant/EmploymentTypeConstant";

const initialState = {
  loading: false,
  action: "Employment_Type",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const EmploymentTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_EMPLOYMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_EMPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_EMPLOYMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GETDETAIL_EMPLOYMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_EMPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_EMPLOYMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_EMPLOYMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_EMPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case ADD_EMPLOYMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_EMPLOYMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EMPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_EMPLOYMENT_TYPE_FAIL:
      return {
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };
    case DELETE_EMPLOYMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_EMPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_EMPLOYMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case CLEAR_EMPTYPE_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default EmploymentTypeReducer;
